/**
 * Details injected into the Privacy Policy, Terms and Impressum.
 *
 * ⚠️ GDPR Art. 13 requires the controller's identity and contact details, and German
 * law (§5 DDG) requires a full Impressum for a site operated by a German company:
 * postal address, register court + HRB number, and managing director. The optional
 * fields below render only when set — fill them in before public launch.
 */
export const LEGAL = {
  /**
   * Name used throughout the legal pages, including the "we are the data controller"
   * line. Set to the brand at the owner's request on 12 Sep 2026.
   *
   * ⚠️ GDPR Art. 13(1)(a) requires the identity of the CONTROLLER, which must be a legal
   * person. Restore the registered operating company here (it is the Apple Developer
   * account holder for team 642J3P53HE) to make the policy identify the controller properly.
   */
  entityName: 'Careumba',
  /** Public-facing product name. */
  brandName: 'Careumba',
  /**
   * TODO(owner): registered postal address, one line per row ("Street 1\n12345 City\nGermany").
   * Required for the Impressum. Leave empty to omit until confirmed.
   */
  address: '',
  /** TODO(owner): register court, e.g. "Amtsgericht München". Required for the Impressum. */
  registerCourt: '',
  /** TODO(owner): commercial register number, e.g. "HRB 123456". Required for the Impressum. */
  registerNumber: '',
  /** TODO(owner): managing director(s). Required for the Impressum. */
  managingDirector: '',
  /** TODO(owner): VAT ID (USt-IdNr.), if the company has one. */
  vatId: '',
  /** Contact for privacy questions and data-subject requests. */
  privacyEmail: 'privacy@careumba.com',
  /** General support contact. */
  supportEmail: 'support@careumba.com',
  /** Last substantive revision. */
  effectiveDate: '23 August 2026',
  /** Where the primary datastore lives — Firestore multi-region `eur3`. */
  dataRegion: 'the European Union (Google Cloud multi-region “eur3”, Belgium and the Netherlands)',
} as const;

/** True when every field a German Impressum needs has been filled in. */
export const hasImpressumDetails = Boolean(
  LEGAL.address && LEGAL.registerCourt && LEGAL.registerNumber && LEGAL.managingDirector
);
